(() => {
  const product = document.querySelector('product-info[data-market-country]');
  const output = product?.querySelector('.ph-delivery-dates');
  if (!output) return;

  const country = product.dataset.marketCountry;
  const label = product.querySelector('.ph-delivery-label');
  if (country !== 'GB' && country !== 'US') {
    if (label) label.textContent = 'Delivery timing';
    output.textContent = 'varies by destination';
    return;
  }

  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(from, count) {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 12);
    let added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    return date;
  }

  function formatDate(date, showYear) {
    const day = weekdays[date.getDay()];
    const month = months[date.getMonth()];
    const year = showYear ? ` ${date.getFullYear()}` : '';
    return country === 'US'
      ? `${day} ${month} ${date.getDate()}${year}`
      : `${day} ${date.getDate()} ${month}${year}`;
  }

  function updateEstimate() {
    const now = new Date();
    const first = addBusinessDays(now, 3);
    const last = addBusinessDays(now, 8);
    const crossesYear = first.getFullYear() !== last.getFullYear();
    output.textContent = `${formatDate(first, crossesYear)} – ${formatDate(last, crossesYear)}`;
  }

  updateEstimate();
  window.setInterval(updateEstimate, 60 * 60 * 1000);
})();
